import controller from './by-search.controller';
import templateBase from './templates/by-search-base.view.html';

let BySearchComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default BySearchComponent;


// WEBPACK FOOTER //
// ./www/components/fast-purchase/by-search/by-search.component.js